import { Element, Class } from "@webhare-system/frameworks/mootools/core";
import * as dompack from 'dompack';
import { Counter } from "../components/basecontrols/counter";
import { getUTF8Length } from "@webhare-system/internal/utf8";

var $todd = require("./support");
var getTid = require("@webhare-tollium/gettid").getTid;
var RTE = require('../components/richeditor');
var TableEditor = require('../components/richeditor/internal/tableeditor');
const domui = require('@webhare-system/internal/legacyui');
require("../components/richeditor/richeditor.lang.json");
var menu = require('@__webhareroot-tollium/web/ui/components/basecontrols/menu');

/****************************************************************************************************************************
 *                                                                                                                          *
 *  RTE                                                                                                                     *
 *                                                                                                                          *
 ****************************************************************************************************************************/

$todd.ObjRTE = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "rte"

, rte: null
, rteoptions: null
, contextmenu: null
, actions: []

, borders: null
, hint: ''
, required: false
, interceptbuttons: []

, valueid: ''

  /// Selection for enabled actions ()
, _selectionflags: [ {} ]
  /// The untouched content, as sent by the server
, untouchedcontent: null
  /// Original restructured HTML content
, restructuredcontent: null

, _showcounter: false
, _countmethod: ""
, _toplaintextmethod: ""
, _textwarnlength: 0

, _counter: 0

, _pendingactiontargetseq:0
, _pendingactiontargets: []

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);

    this.hint = data.hint;
    this.required = data.required;
    this.interceptbuttons = data.interceptbuttons;
    this.isemaileditor = data.areatype == 'email'; //FIXME gaat dit nbu wel via 'type' of 'areatype' ?
    this.borders = data.borders;
    this._showcounter = data.showcounter;
    this._countmethod = data.countmethod;
    this._toplaintextmethod = data.toplaintextmethod;
    this._warnlength = data.warnlength;

    var hidebuttons = [];
    if(!data.allownewembeddedobjects)
      hidebuttons.push('object-insert');
    if(!data.allowvideo)
      hidebuttons.push('object-video');
    if(!data.structure || !data.structure.blockstyles.some(function(style) { return style.type == "table"; }))
      hidebuttons.push('table');

    this.rteoptions =
      { enabled: data.enabled
      , readonly: data.readonly
      , backgroundcolor: 'transparent'

      , actionelements:
            [ { element:"table", hasclasses: ["wh-rtd__table"] }
            ]

      //FIXME
      , onStatechange: this._onRTEStateChange.bind(this)
      //FIXME
      , language: 'en'//parent.app.lang      // FIXME
      //, log:true
      , allowtags: data.allowtags.length ? data.allowtags : null
      , structure: data.structure
      , csslinks: [data.cssurl]
      , cssinstance: data.cssinstance
      , breakupnodes: this.isemaileditor ? [ 'blockquote' ] : []
      , hidebuttons: hidebuttons
      , htmlclass: data.htmlclass
      , bodyclass: data.bodyclass
      , csscode: data.csscode
      };

    if(!this.rteoptions.structure)
    {
      //ADDME standard styling should be class-selectable and implemented by designfiels rte css itself or a theme
      this.rteoptions.csscode = '.' + data.cssinstance + '.wh-rtd-editor-htmlnode { font: 0.7em Tahoma,"Lucida Grande","DejaVu Sans",freesans,arial,helvetica,sans-serif; }\n'
                                +'.' + data.cssinstance + ' blockquote { border: #666666 solid 0; border-left-width: 2px; margin: 5px 0; padding: 0 5px; color: #555555; }\n'
                                +'.' + data.cssinstance + ' blockquote blockquote { color: #666666; }\n'
                                +'.' + data.cssinstance + ' blockquote blockquote blockquote { color: #777777; }\n'
                                +'.' + data.cssinstance + ' p { padding:0; margin: 0}\n';
    }

    // Build our DOM
    this.buildNode();
    this.valueid = data.valueid;
    this.setValue(data.value);
//    this.constructContextMenu();
  }

, destroy:function()
  {
    this.rte.destroy();
    this.parent();
  }

/****************************************************************************************************************************
* Property getters & setters
*/

, setValue:function(newvalue) //set from server
  {
    if(this.untouchedcontent == newvalue)
      return console.log("RTE: server sent an unneeded update");
    this.untouchedcontent = newvalue;
    this.rte.setValue(newvalue);
    this.restructuredcontent = this.rte.getValue();
    if(this.restructuredcontent != this.untouchedcontent)
      console.warn("Dirty on startup!");
  }

, getSubmitValue: function()
  {
    let suggestedreturnvalue = this.rte.getValue();
    if (suggestedreturnvalue == this.restructuredcontent) //no material change ( FIXME Let the RTD implement this)
    {
      console.log("Returning untouched value");
      return this.untouchedcontent;
    }
    else
    {
      console.log("Returning updated value");
      return suggestedreturnvalue;
    }
  }


/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = new Element('t-rte', { "data-name": this.name
                                     });
    this.node.addEventListener("wh:menu-activateitem", evt => this._activateRTDMenuItem(evt));
    this.rte = new RTE(this.node, this.rteoptions);
    if(this.rteoptions.structure)
      this.node.classList.add("structured");

    if (this._showcounter)
    {
      this._counter = new Counter({ count: 0, limit: this._warnlength });
      this.node.appendChild(this._counter.node);
    }

    ["top","right","bottom","left"].forEach(function(bordername)
    {
      // 1px is the default from designfiles css
      if (this.borders && !this.borders[bordername])
        this.node.setStyle("border-" + bordername + "-width", "0px");
    }.bind(this));

    this.node.store("todd", this);
    this.node.store("todd-rte", this.rte);
    this.node.addEventListener("wh:richeditor-action", this._doExecuteAction.bind(this));
    this.node.addEventListener("wh-rtd-dirty", this._gotDirty.bind(this));
    this.node.addEventListener("contextmenu", this._gotContextMenu.bind(this));
  }

/****************************************************************************************************************************
* Dimensions
*/

, calculateDimWidth: function()
  {
    this.width.min = 200;
  }

, calculateDimHeight: function()
  {
    this.height.min = 120;
  }

, relayout: function()
  {
    this.debugLog("dimensions", "relayouting set width=" + this.width.set + ", set height="+ this.height.set);
    this.node.style.width = this.width.set + 'px';
    this.node.style.height = this.height.set + 'px';
  }


/****************************************************************************************************************************
* Component state
*/

, enabledOn: function(checkflags, min, max, selectionmatch)
  {
    return $todd.Screen.checkEnabledFlags(this._selectionflags, checkflags, min, max, selectionmatch);
  }

  // ---------------------------------------------------------------------------
  //
  // Context menu
  //

, _gotContextMenu: function(event)
  {
    if (domui.isAllowNativeContextMenu(event))
      return;

    event.stopPropagation();
    event.preventDefault();

    let contextmenu = dompack.create('ul', );
    let actionstate = this.rte.getSelectionState().actionstate;
    for(let item of [ { action: "table-addrow-before", title: getTid("tollium:components.rte.table_addrow_before") }
                    , { action: "table-addrow-after", title: getTid("tollium:components.rte.table_addrow_after") }
                    , null
                    , { action: "table-addcolumn-before", title: getTid("tollium:components.rte.table_addcolumn_before") }
                    , { action: "table-addcolumn-after", title: getTid("tollium:components.rte.table_addcolumn_after") }
                    , null
                    , { action: "table-deleterow", title: getTid("tollium:components.rte.table_deleterow")  }
                    , { action: "table-deletecolumn", title: getTid("tollium:components.rte.table_deletecolumn")  }
                    , null
                    , { action: "table-addpara-before", title: getTid("tollium:components.rte.table_addpara_before")  }
                    , { action: "table-addpara-after", title: getTid("tollium:components.rte.table_addpara_after")  }
                    , null
                    , { action: "action-properties", title: getTid("tollium:components.rte.properties")  }
                    ])
    {
      if(!item)
      {
        contextmenu.appendChild(dompack.create('li', {className:'divider'}));
        continue;
      }

      if(actionstate[item.action].available)
      {
        contextmenu.appendChild(dompack.create('li', { textContent: item.title
                                                     , dataset: { action: item.action }
                                                     }));
      }
    }

    menu.openAt(contextmenu, event, {eventnode:this.node});
  }

, _activateRTDMenuItem:function(evt)
  {
    evt.stopPropagation();
    this.rte.executeAction(evt.detail.menuitem.dataset.action);
  }

/****************************************************************************************************************************
* Events
*/
, _doExecuteAction: function(event, lock)
  {
    var action = event.detail.action;

    if(["a-href","object-insert","object-video"].contains(action))
    {
      event.stopPropagation();
      event.preventDefault();
      this.doButtonClick(action);
    }
    if(action == "action-properties")
    {
      this._gotPropertiesEvent(event);
    }
    if(action == "p-id")
    {
      event.stopPropagation();
      event.preventDefault();
      this.queueMessage('p-id', { currentanchor: event.detail.currentanchor || ''}, true, lock && lock.release.bind(lock));
      return;
    }
    if (lock)
      lock.release();
  }

, doButtonClick: function(buttonname, params)
  {
    var data = { button: buttonname };
    if (params)
      data.params = params;
    this.queueMessage('buttonclick', data, true);
  }

, _onRTEStateChange: function()
  {
    var selstate = this.rte ? this.rte.getSelectionState() : null;
    var actionstate = selstate ? selstate.actionstate : {};

    var have_change = false;

    var row = this._selectionflags[0];
    Object.keys(actionstate).each(function(key)
    {
      var available = actionstate[key].available || false;
      if (row[key] !== available)
      {
        have_change = true;
        row[key] = available;
      }
    }.bind(this));

    if (have_change)
    {
      // Update enabled status for actions
      this.actions.each(function(action) { action.checkEnabled(); });
    }

    if (this._showcounter)
      this._updateCounter();
  }

, _updateCounter: function()
  {
    if (!this.rte)
      return;

    let count = 0;

    let text = this.rte.getPlainText(this._toplaintextmethod);
    if (this._countmethod === "plaintext:characters")
      count = text.length;
    else if (this._countmethod === "plaintext:bytes")
      count = getUTF8Length(text.length);

    this._counter.update({ count: count });
  }

, getParentElement: function(element, gettag)
  {
    gettag=gettag.toUpperCase();
    for (var findparent=element;findparent;findparent=findparent.parentNode)
      if(findparent.nodeName.toUpperCase()==gettag)
        return findparent;
    return null;
  }

, _gotPropertiesEvent: function(event)
  {
    //FIXME we need to stop direct RTE manipulation and start using 'offiical' APIs offered by the richeditor/index.es
    if(event.detail.actiontarget)
    {
      let affectednodeinfo = event.detail.rte.getTargetInfo(event.detail.actiontarget);
      if(affectednodeinfo) //new properties API may not require any rework from us at all, except from not transmitting the node itself over JSON
      {
        //preserve the actiontarget - the RTE will need it when the response comes in
        let actionid = ++this._pendingactiontargetseq;
        this._pendingactiontargets.push( { id: actionid, target: event.detail.actiontarget });

        //the rest of the data is built to be JSON-safe
        this.queueMessage('properties2', { actionid, affectednodeinfo }, true);
        event.preventDefault();
        return;
      }
    }

    var targetid = event.detail.targetid;
    var target = event.target;
    var subaction = event.detail.subaction;

    //The image 'targetid' is being editted. gather its properties and inform our parent
    if(target.nodeName.toUpperCase()=='IMG')
    {
      var widthattr = target.getAttribute("width");
      var heightattr = target.getAttribute("height");
      var props = { targetid: targetid
                  , type: 'img'
                  , align: ''
                  , width: (widthattr ? widthattr.toInt() : 0) || target.width
                  , height: (heightattr ? heightattr.toInt() : 0) || target.height
                  , alttext: target.alt
                  , link: null
                  , src: target.src
                  };

      if(target.classList.contains("wh-rtd__img--floatleft"))
        props.align='left';
      else if(target.classList.contains("wh-rtd__img--floatright"))
        props.align='right';
//      else if(target.align=='left' || target.align=='right')
  //      props.align=target.align; //backwards compatibility

      var link = this.getParentElement(target, 'A');
      if(link && link.href)
        props.link = { link: link.getAttribute("href")
                     , target: link.getAttribute("target") || ''
                     };

      this.queueMessage('properties', props, true);
      event.preventDefault();
    }
    else if(target.nodeName.toUpperCase()=='DIV' && (target.hasClass("wh-rtd-embeddedobject") || target.hasClass("-wh-rtd-embeddedobject")))
    {
      let props = { targetid: targetid
                  , type: 'embeddedobject'
                  , instanceref: target.getAttribute('data-instanceref')
                  , subaction: subaction
                  };
      this.queueMessage('properties', props, true);
      event.preventDefault();
    }
    else if(target.nodeName.toUpperCase()=='TABLE')
    {
      var editor = TableEditor.getEditorForNode(target);
      if (editor)
      {
        let props = { targetid: targetid
                    , type: 'table'
                    , datacell: editor.locateFirstDataCell()
                    , numrows: editor.numrows
                    , numcols: editor.numcols
                    , styletag: editor.node.classList[0]
                    };
        this.queueMessage('properties', props, true);
      }
      event.preventDefault();
    }
  }

, _gotDirty: function()
  {
    this.queueMessage("dirty", { valueid: this.valueid });
  }

, onMsgInsertAnchor:function(data)
  {
    this.rte.getEditor().setAnchor(data.name);
  }

, onMsgUpdateProps2:function(data)
  {
    console.error(data,this._pendingactiontargets,this._pendingactiontargets[0]);
    let actiontargetidx = this._pendingactiontargets.findIndex(pendingtarget => pendingtarget.id == data.actionid);
    if(actiontargetidx == -1)
    {
      console.log("Received update for unknown actiontarget #" + data.actionid, data);
      return;
    }

    let actiontarget = this._pendingactiontargets[actiontargetidx].target;
    this._pendingactiontargets.splice(actiontargetidx, 1);

    if(!data.settings) //it's just a cancellation
      return;

    this.rte.updateTarget(actiontarget, data.settings);
  }

, onMsgUpdateProps:function(data)
  {
    //FIXME we need to stop direct RTE manipulation and start using 'offiical' APIs offered by the richeditor/index.es
    var targetid = data.targetid;
    var newdata = data.newdata;


    var target = this.rte.getActionTarget(targetid);
    if(!target)
      return; //unable to match the target, too bad...

    switch (target.nodeName.toUpperCase())
    {
      case "IMG":
      {
        target.width = newdata.width;
        target.height = newdata.height;
        target.align = '';
        target.alt = newdata.alttext;
        target.className = "wh-rtd__img" + (newdata.align=='left' ? " wh-rtd__img--floatleft" : newdata.align=="right" ? " wh-rtd__img--floatright" : "");

        var link = this.getParentElement(target, 'A');
        if(link && !newdata.link) //remove the hyperlink
        {
          console.warn("ADDME: Calling low level APIs here, cleanup or approve - would prefer not to disturb selection");
          this.rte.getEditor().selectNodeOuter(target);
          this.rte.getEditor().removeHyperlink();
        }
        else if (newdata.link) //add a hyperlink
        {
          console.warn("ADDME: Calling low level APIs here, cleanup or approve - would prefer not to disturb selection");
          if(!link)
          {
            this.rte.getEditor().selectNodeOuter(target);
            this.rte.getEditor().insertHyperlink(newdata.link.link);
            link = this.getParentElement(target, 'A');
            if(!link)
              return console.error("Somehow <A> construction failed");
          }

          link.href = newdata.link.link;
          link.target = newdata.link.target || '';
        }
      } break;
      case "DIV":
      {
        if(target.hasClass("-wh-rtd-embeddedobject") || target.hasClass("wh-rtd-embeddedobject"))
        {
          //we'll simply reinsert
          if (newdata)
          {
            if (newdata.type == 'replace')
            {
              this.rte.getEditor().updateEmbeddedObject(target, newdata.data);
            }
            else if (newdata.type == 'remove')
            {
              this.rte.getEditor().removeEmbeddedObject(target);
            }
          }
        }
      } break;
      case "TABLE":
      {
        switch (newdata.type)
        {
          case "edittable":
          {
            var editor = TableEditor.getEditorForNode(target);
            if (editor)
            {
              editor.setFirstDataCell(newdata.datacell.row, newdata.datacell.col);
              editor.setStyleTag(newdata.styletag);
            }
          } break;
          case "remove":
          {
            this.rte.getEditor().removeTable(target);
          } break;
        }
      } break;
      default:
      {
        console.log('classes'. target.className.split(' '));
      }
    }
  }

, onMsgUpdateValue:function(data)
  {
    this.valueid = data.valueid;
    this.setValue(data.value);
  }

, onMsgInsertHyperlink:function(data)
  {
    this.rte.getEditor().insertHyperlink(data.url, { target: data.target });
  }

, onMsgInsertEmbeddedObject: function(data)
  {
    this.rte.getEditor().insertEmbeddedObject(data);
  }

, onMsgUpdateEnabled:function(data)
  {
    this.rte.setEnabled(data.value);
  }

, onMsgUpdateClasses:function(data)
  {
    this.rte.setHTMLClass(data.htmlclass);
    this.rte.setBodyClass(data.bodyclass);
  }

, onMsgAckDirty: function()
  {
    // Used to send an empty response on the 'dirty' async message, so the comm layer gets an ack
    // on the message, which the test framework needs to complete 'waits: ["tollium"]'
  }
});

exports.components = { rte: $todd.ObjRTE };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/rte.es